import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../shell/Logo';
interface Props {
  title: string;
  intro: string;
  children: React.ReactNode;
  /** Recovery and help links, shown under the form. */
  footer?: React.ReactNode;
}

/**
 * Shared chrome for every authentication screen, so signing in never feels
 * like a different product from the rest of Campuzon.
 */
export function AuthLayout({
  title,
  intro,
  children,
  footer
}: Props) {
  return <div className="min-h-screen w-full bg-canvas" data-id="element-537" data-mp="ab2n7gg5zzzr">
      <header className="border-b border-line bg-surface" data-id="element-538" data-mp="fax9f6ozw1eh">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3.5 sm:px-6" data-id="element-539" data-mp="1c7cps6383qn">
          <Link to="/welcome" className="rounded-md" data-id="element-540" data-mp="6b1xv0rj24dx">
            <Logo variant="stacked" data-id="element-541" data-mp="69h1d5lnkbdf" />
          </Link>
          <Link to="/welcome" className="cz-inline-link min-h-touch inline-flex items-center text-body-sm" data-id="element-542" data-mp="2m1wsc7em7tke">
            Back to Campuzon
          </Link>
        </div>
      </header>

      <main className="mx-auto w-full max-w-lg px-4 py-8 sm:px-6 sm:py-12" data-id="element-543" data-mp="42ejtyblb9zn">
        <h1 className="text-h2 font-semibold text-ink" data-id="element-544" data-mp="3v868et9pyekc">{title}</h1>
        <p className="mt-2 max-w-[60ch] text-body text-ink-muted" data-id="element-545" data-mp="3va0voe8gqirl">{intro}</p>

        <div className="mt-6 rounded-card border border-line bg-surface p-5 shadow-panel sm:p-6" data-id="element-546" data-mp="e141pr3hkufw">
          {children}
        </div>

        {footer && <div className="mt-5 text-body-sm text-ink-muted" data-id="element-547" data-mp="mzxzhksjzqv1">{footer}</div>}

        <p className="mt-8 border-t border-line pt-4 text-caption text-ink-muted" data-id="element-548" data-mp="mxuxe2e4m79y">
          By using Campuzon you agree to the{' '}
          <Link to="/welcome#terms" className="cz-inline-link" data-id="element-549" data-mp="wqk4ym6k3100">
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link to="/welcome#privacy" className="cz-inline-link" data-id="element-550" data-mp="rrfyw4exhjdw">
            Privacy Policy
          </Link>
          . Campuzon never asks for your university password.
        </p>
      </main>
    </div>;
}